import { Box } from '@material-ui/core';
import { getMerchantById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { MerchantContractAndDetails } from '@/components/modules/MerchantDetail/MerchantCompliance/components/MerchantContract/MerchantContractAndDetails';
import { ModuleCorePermissionProps } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const MerchantCompliance = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { merchantId } = useParams();

  if (!merchantId) return null;

  const { data: merchant, loading } = useCache(getMerchantById, { merchantId });

  useSetPageLoadingWhenRequesting('MERCHANT', [loading]);

  if (!merchant) return null;

  return (
    <Box>
      <MerchantContractAndDetails merchant={merchant} editModeAllowed={canEdit} />
    </Box>
  );
};

export const MerchantComplianceModule = withPermissionsModule(MerchantCompliance);
